/* Good Too Golf — progressive enhancement over Shopify's native forms. */
(() => {
 'use strict';
 const root = window.Shopify?.routes?.root || '/';
 let cartBusy = false;
 const openings = new WeakMap();
 function openDialog(dialog, trigger) {
  if (!dialog || typeof dialog.showModal !== 'function') return false;
  openings.set(dialog, trigger || document.activeElement);
  if (!dialog.open) dialog.showModal();
  const video = dialog.querySelector('video[data-film-src]');
  if (video) { if (!video.src) video.src = video.dataset.filmSrc; video.play().catch(() => {}); }
  return true;
 }
 function setupDialog(dialog) {
  if (dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  dialog.addEventListener('close', () => {
   dialog.querySelectorAll('video').forEach(v => v.pause());
   const trigger = openings.get(dialog); if (trigger?.isConnected) trigger.focus();
  });
  dialog.addEventListener('click', event => {
   if (event.target !== dialog) return;
   const r = dialog.getBoundingClientRect();
   if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
 }
 document.querySelectorAll('dialog').forEach(setupDialog);
 document.addEventListener('shopify:section:load', () => document.querySelectorAll('dialog').forEach(setupDialog));
 async function request(url, options) {
  const response = await fetch(url, options);
  const body = await response.json();
  if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : typeof body.message === 'string' ? body.message : 'We couldn’t update your bag. Please try again.');
  return body;
 }
 async function refreshCart() {
  const [cart, htmlResponse] = await Promise.all([request(root + 'cart.js'), fetch(root + 'cart?section_id=cart-drawer')]);
  if (!htmlResponse.ok) throw new Error('Your bag could not refresh. Open the bag page to see the latest items.');
  const html = await htmlResponse.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const content = doc.querySelector('[data-cart-body]');
  const target = document.querySelector('#cart-drawer [data-cart-body]');
  if (!content || !target) throw new Error('Your bag could not refresh. Please open the bag page.');
  const pageTarget = document.querySelector('[data-cart-page-body]');
  if (pageTarget) {
   const pageContent = content.cloneNode(true);
   pageContent.querySelectorAll('[id]').forEach(el => { el.id = el.id.replace('-drawer', '-page'); });
   pageContent.querySelectorAll('label[for]').forEach(el => { el.htmlFor = el.htmlFor.replace('-drawer', '-page'); });
   pageTarget.replaceChildren(...Array.from(pageContent.childNodes));
  }
  target.replaceChildren(...Array.from(content.childNodes));
  document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
  return cart;
 }
 function showMedia(id, scope = document) {
  const target = document.getElementById(id); if (!target) return;
  const gallery = target.closest('.product-gallery') || scope;
  gallery.querySelectorAll('.gallery-media').forEach(el => { el.hidden = el !== target; if (el.hidden) el.querySelectorAll('video').forEach(v => v.pause()); });
  gallery.querySelectorAll('[data-show-media]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.showMedia === id)));
 }
 document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-open-dialog]');
  if (trigger) openDialog(document.getElementById(trigger.dataset.openDialog), trigger);
  const close = event.target.closest('[data-close-dialog]'); if (close) close.closest('dialog')?.close();
  const cartLink = event.target.closest('[data-open-cart]');
  if (cartLink && openDialog(document.getElementById('cart-drawer'), cartLink)) { event.preventDefault(); if (!cartBusy) refreshCart().catch(() => { window.location.assign(cartLink.href); }); }
  const step = event.target.closest('[data-quantity-step]');
  if (step) { const input = step.closest('.qty').querySelector('input'); input.value = String(Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(step.dataset.quantityStep)))); input.dispatchEvent(new Event('change', {bubbles:true})); }
  const media = event.target.closest('[data-show-media]'); if (media) showMedia(media.dataset.showMedia);
  const remove = event.target.closest('#cart-drawer [data-remove-key]');
  if (remove) { event.preventDefault(); mutateCart(remove.dataset.removeKey, 0, remove); }
 });
 document.addEventListener('change', event => {
  const input = event.target;
  if (input.matches('.product-form input[name="id"]')) {
   const form = input.closest('form'); form.querySelectorAll('.sizes label').forEach(label => label.classList.toggle('selected', label.contains(input)));
   const price = form.closest('.product-info').querySelector('[data-product-price]');
   if (price && input.dataset.variantPrice) price.textContent = input.dataset.variantPrice;
   if (input.dataset.variantImage) showMedia(input.dataset.variantImage);
   const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState(null, '', url);
  }
  if (input.matches('#cart-drawer [data-line-key]')) {
   if (!input.checkValidity()) { input.reportValidity(); return; }
   mutateCart(input.dataset.lineKey, Number(input.value), input);
  }
 });
 async function mutateCart(key, quantity, trigger) {
  if (cartBusy) return;
  cartBusy = true;
  const form = trigger.closest('form'); const focusId = trigger.id;
  const note = form.querySelector('[name="note"]')?.value;
  const error = form.querySelector('[data-cart-error]'); if (error) error.textContent = '';
  form.setAttribute('aria-busy', 'true');
  try {
   // Persist the note before refreshing the rendered drawer.
   if (note !== undefined) await request(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note})});
   await request(root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
   const cart = await refreshCart();
   document.getElementById('cart-status').textContent = 'Bag updated. ' + cart.item_count + ' items.';
   (document.getElementById(focusId) || document.querySelector('#cart-drawer [data-close-dialog]'))?.focus();
  } catch (e) {
   if (error) error.textContent = e.message;
  } finally {cartBusy = false; form.removeAttribute('aria-busy');}
 }
 document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-product-form]')) return;
  event.preventDefault();
  if (cartBusy || !form.reportValidity()) return;
  cartBusy = true;
  const button = form.querySelector('[type="submit"]'); const error = form.querySelector('[data-product-error]');
  button.disabled = true; form.setAttribute('aria-busy', 'true'); error.textContent = '';
  let added = false;
  try {
   await request(root + 'cart/add.js', {method:'POST',body:new FormData(form)}); added = true;
   const cart = await refreshCart();
   document.getElementById('cart-status').textContent = 'Added to your bag. ' + cart.item_count + ' items.';
   if (!openDialog(document.getElementById('cart-drawer'), button)) window.location.assign(root + 'cart');
  } catch (e) {
   error.textContent = added ? 'Your item was added. Open the bag page to review it before adding again.' : e.message;
   if (added) { const link = document.createElement('a');link.href=root+'cart';link.textContent=' View bag';link.style.textDecoration='underline';error.append(link); }
  } finally { button.disabled=false;form.removeAttribute('aria-busy');cartBusy=false; }
 });
 // Deep-linked variants can select their matching gallery image immediately.
 document.querySelectorAll('.product-form input[name="id"]:checked').forEach(input => { if(input.dataset.variantImage) showMedia(input.dataset.variantImage); });
})();
